import dateUtil from './dateUtil';

const getTodayDateTime = (format: string): string => dateUtil().format(format);

export default getTodayDateTime;
